// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/currency.proto (package squareup.common, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CurrencyCode } from "./currency_codes_pb";
import { file_squareup_common_currency_codes } from "./currency_codes_pb";
import { file_squareup_objc_objc } from "../objc/objc_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/currency.proto.
 */
export const file_squareup_common_currency: GenFile = /*@__PURE__*/
  fileDesc("Ch5zcXVhcmV1cC9jb21tb24vY3VycmVuY3kucHJvdG8SD3NxdWFyZXVwLmNvbW1vbiJSCgVNb25leRIOCgZhbW91bnQYAiABKAMSOQoNY3VycmVuY3lfY29kZRgDIAEoDjIdLnNxdWFyZXVwLmNvbW1vbi5DdXJyZW5jeUNvZGU6A1VTREI0Chpjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbkIOQ3VycmVuY3lQcm90b3PCmwMEQ0NVUg", [file_squareup_common_currency_codes, file_squareup_objc_objc]);

/**
 * Next id: 4
 * See https://git.sqcorp.co/projects/SQ/repos/docs/browse/api/money.md
 *
 * @generated from message squareup.common.Money
 */
export type Money = Message<"squareup.common.Money"> & {
  /**
   * * 
   * Smallest divisible unit of currency for a given locale,
   * scaled by the default number of decimal places for the currency.
   * For example, amount = 100 in USD means $1.00.
   *
   * @generated from field: optional int64 amount = 2;
   */
  amount: bigint;

  /**
   * * 
   * Character string repesenting ISO-4217 currency codes.
   * @see http://www.currency-iso.org/dl_iso_table_a1.xml
   *
   * @generated from field: optional squareup.common.CurrencyCode currency_code = 3 [default = USD];
   */
  currencyCode: CurrencyCode;
};

/**
 * Describes the message squareup.common.Money.
 * Use `create(MoneySchema)` to create a new message.
 */
export const MoneySchema: GenMessage<Money> = /*@__PURE__*/
  messageDesc(file_squareup_common_currency, 0);

